import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { findServices, setBidService, type FoundService } from '../detailApi';
import { errorMessage, useBidAction } from './useBidAction';

const NOT_FOUND = 'СТО с указанным ID или названием не найдено';

/** Distributes a premoderation bid to a service found by id or name (legacy `DistributeBid`). */
export const DistributeBidBlock = ({ bidId }: { bidId: number }) => {
  const [query, setQuery] = useState('');
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [searchError, setSearchError] = useState('');

  const search = useMutation({
    mutationFn: findServices,
    onSuccess: (found) => {
      setSearchError(found.length ? '' : NOT_FOUND);
      // A single match is selected right away, otherwise the operator picks one.
      setSelectedId(found.length === 1 ? found[0].id : null);
    },
    onError: (error) => setSearchError(errorMessage(error)),
  });
  const distribute = useBidAction(bidId, (serviceId: number) => setBidService(bidId, serviceId));

  const services: FoundService[] = search.data ?? [];

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    if (!query.trim()) {
      setSearchError('Введите ID или название СТО');
      return;
    }
    setSelectedId(null);
    search.mutate(query);
  };

  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">Распределение заявки</h3>
      </div>
      <div className="box-body">
        <p>
          <b>Заявка не распределена. Найдите СТО по ID или названию:</b>
        </p>
        <form className="form-inline" onSubmit={submitSearch}>
          <input
            className="form-control input-sm"
            style={{ minWidth: 260, marginRight: 10 }}
            placeholder="ID или название СТО"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit" className="btn btn-default btn-sm" disabled={search.isPending}>
            Фильтр
          </button>
        </form>
        {(searchError || distribute.error) && (
          <p className="text-danger" style={{ marginTop: 10 }}>
            {searchError || distribute.error}
          </p>
        )}
        {services.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {services.map((service) => (
              <div className="radio" key={service.id}>
                <label>
                  <input
                    type="radio"
                    name="distribute-service"
                    checked={selectedId === service.id}
                    onChange={() => setSelectedId(service.id)}
                  />
                  {`#${service.id} ${service.name || 'Без названия'}${service.phone ? `, +${service.phone}` : ''}`}
                </label>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              disabled={selectedId === null || distribute.isPending}
              onClick={() => selectedId !== null && distribute.run(selectedId)}
            >
              Распределить
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
